export const APP_VERSION = 'bdefc52';
